import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-download-01",
  "use": "icon-download-01-usage",
  "viewBox": "0 0 18 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 16\" id=\"icon-download-01\">\r\n  <defs>\r\n    <style>\r\n      #icon-download-01 .cls-1 {\r\n        fill: #347aeb;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <path id=\"icon-download-01_l_710\" data-name=\"l 710\" class=\"cls-1\" d=\"M149.086,200.95v-6.769h2.25v6.769h3.375l-4.5,4.513-4.5-4.513h3.375Zm7.875.205h2.25v6.769a2.254,2.254,0,0,1-2.25,2.256h-13.5a2.254,2.254,0,0,1-2.25-2.256v-6.771h2.25v6.769h13.5v-6.769Z\" transform=\"translate(-141.211 -194.181)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol